// components/PrivacyPolicyAgree.js
import React from "react";

function PrivacyPolicyAgree({
  isAgreed,
  setIsAgreed,
  togglePrivacyPolicyModal,
  privacyMessage,
  styleOptions,
}) {
  return (
    <p
      className="privacyPolicyAgree"
      style={styleOptions ? { marginTop: 0 } : undefined}
    >
      <input
        type="checkbox"
        id="privacyPolicyAgree"
        checked={isAgreed}
        onChange={() => setIsAgreed(!isAgreed)}
      />
      <label htmlFor="privacyPolicyAgree">
        {privacyMessage ||
          "개인정보 수집 및 이용에 관한 내용을 확인하고 동의함"}
      </label>
      <span onClick={togglePrivacyPolicyModal}> [자세히보기]</span>
    </p>
  );
}

export default PrivacyPolicyAgree;
